import { Languages } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { cn } from "@/lib/utils";

export function LangToggle({ dark = false, className }) {
  const { lang, setLang } = useLang();
  const opt = (value, label) => (
    <button key={value} onClick={() => setLang(value)} data-testid={`lang-${value}-btn`}
      aria-pressed={lang === value}
      className={cn("rounded-full px-2.5 py-1 text-[11px] font-bold transition-colors",
        lang === value
          ? (dark ? "bg-white text-slate-900" : "bg-slate-900 text-white")
          : (dark ? "text-white/70 hover:text-white" : "text-muted-foreground hover:text-foreground"))}>
      {label}
    </button>
  );
  return (
    <div data-testid="lang-toggle"
      className={cn("inline-flex items-center gap-0.5 rounded-full border p-0.5", dark ? "border-white/20 bg-white/10" : "border-border bg-card", className)}>
      <Languages className={cn("ml-1.5 h-3.5 w-3.5", dark ? "text-white/70" : "text-muted-foreground")} />
      {opt("en", "EN")}
      {opt("hi", "Hinglish")}
    </div>
  );
}
